import crashlytics from './crashlytics.web';
export {crashlytics};
